var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"about"},[_c('h1',[_vm._v("This is an about page")]),_c('v-card',[_c('v-card-actions',[_c('v-btn',[_vm._v("test")])],1),_c('v-card-text',[_vm._v("\n      dffsdf\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }